/**
 * Side-effect-only module: must be the FIRST import in `main.tsx`.
 *
 * A third-party browser dependency reads bare `process.env` synchronously
 * when the module is evaluated.
 * In a browser, that throws `ReferenceError: process is not defined`.
 *
 * The polyfill MUST run before any other module loads — otherwise ESM
 * hoists the other `import` declarations above this code and the
 * dependency runs first, crashing module evaluation before React ever mounts.
 *
 * Keep this file imported as `import "@/app/process-polyfill";` (no
 * destructuring) so it executes purely for side-effects.
 */

if (typeof globalThis.process === "undefined") {
	(
		globalThis as unknown as { process: { env: Record<string, string> } }
	).process = {
		env: { NODE_ENV: import.meta.env.MODE },
	};
}
